module.exports = __webpack_public_path__ + "static/media/arrow-button-tiles-right-off.16263eab.svg";